import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {UserSessionStoreService as StoreService} from '@drl/core/store/user-session-store.service';
import { PrescriptionBulk } from '../../prescription-bulk.model';

@Injectable()
export class BulkPrescriptionAdapter implements IAdapter<PrescriptionBulk> {
  constructor(private readonly store: StoreService) {}

  adaptToModel(resp: PrescriptionBulk): PrescriptionBulk {
    return resp;
  }
  // sonarignore:start
  adaptFromModel(data: PrescriptionBulk): any {
    data.prescriptions.forEach((presc)=>{
      delete presc.uniqId;
      delete presc.prescDateTimeString;
      delete presc.patientName;
      delete presc.mobile;
      delete presc.patientExternalId;
      delete presc.searchBy;
      delete presc.doctorUserId;
      presc.startDate = presc.prescriptionDate;
      if(presc.medicines){
        presc.medicines.forEach((med: any)=>{
          delete med.editable;
          med.instructions = med.description;
          delete med.description;
          med.frequency = Number(med.frequency);
          med.duration = Number(med.duration);
          med.dosage = Number(med.dosage);
        });
      }
    });
    return [...data.prescriptions];
  // sonarignore:end
  }
}
